export function removeLastLetter(text: string, number: number) {
  if (text) {
    const newString = text.substring(0, text.length - number);
    return newString;
  }
}
